import React from "react";

export const Archive = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
      <path fill="currentColor" d="M32 448c0 17.7 14.3 32 32 32h384c17.7 0 32-14.3 32-32V160H32v288zm160-212c0-6.6 5.4-12 12-12h104c6.6 0 12 5.4 12 12v8c0 6.6-5.4 12-12 12H204c-6.6 0-12-5.4-12-12v-8zM480 32H32C14.3 32 0 46.3 0 64v48c0 8.8 7.2 16 16 16h480c8.8 0 16-7.2 16-16V64c0-17.7-14.3-32-32-32z" />
    </svg>
  );
};

export const ArrowDown = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 255 255">
      <g fill="currentColor">
        <polygon fill="currentColor" points="0,63.75 127.5,191.25 255,63.75" />
      </g>
    </svg>
  );
};

export const Calendar = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
      <path fill="currentColor" d="M148 288h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12zm108-12v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm96 0v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm-96 96v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm-96 0v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm192 0v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm96-260v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V112c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48zm-48 346V160H48v298c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"></path>
    </svg>
  );
};

export const ChevronCircleRight = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
      <path fill="currentColor" d="M256 8c137 0 248 111 248 248S393 504 256 504 8 393 8 256 119 8 256 8zm113.9 231L234.4 103.5c-9.4-9.4-24.6-9.4-33.9 0l-17 17c-9.4 9.4-9.4 24.6 0 33.9L285.1 256 183.5 357.6c-9.4 9.4-9.4 24.6 0 33.9l17 17c9.4 9.4 24.6 9.4 33.9 0L369.9 273c9.4-9.4 9.4-24.6 0-34z"></path>
    </svg>
  );
};

export const CommentDots = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
      <path fill="currentColor" d="M256 32C114.6 32 0 125.1 0 240c0 49.6 21.4 95 57 130.7C44.5 421.1 2.7 466 2.2 466.5c-2.2 2.3-2.8 5.7-1.5 8.7S4.8 480 8 480c66.3 0 116-31.8 140.6-51.4 32.7 12.3 69 19.4 107.4 19.4 141.4 0 256-93.1 256-208S397.4 32 256 32zM128 272c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm128 0c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm128 0c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z" />
    </svg>
  );
};

export const Facebook = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 96.124 96.123">
      <path
        fill="currentColor"
        d="M72.089,0.02L59.624,0C45.62,0,36.57,9.285,36.57,23.656v10.907H24.037c-1.083,0-1.96,0.878-1.96,1.961v15.803
          c0,1.083,0.878,1.96,1.96,1.96h12.533v39.876c0,1.083,0.877,1.96,1.96,1.96h16.352c1.083,0,1.96-0.878,1.96-1.96V54.287h14.654
          c1.083,0,1.96-0.877,1.96-1.96l0.006-15.803c0-0.52-0.207-1.018-0.574-1.386c-0.367-0.368-0.867-0.575-1.387-0.575H56.842v-9.246
          c0-4.444,1.059-6.7,6.848-6.7l8.397-0.003c1.082,0,1.959-0.878,1.959-1.96V1.98C74.046,0.899,73.17,0.022,72.089,0.02z"
      />
    </svg>
  );
};

export const Pinterest = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 144 144">
      <path fill="currentColor" d="M71.9,5.4C35.1,5.4,5.3,35.2,5.3,72c0,28.2,17.5,52.3,42.3,62c-0.6-5.3-1.1-13.3,0.2-19.1    c1.2-5.2,7.8-33.1,7.8-33.1s-2-4-2-9.9c0-9.3,5.4-16.2,12-16.2c5.7,0,8.4,4.3,8.4,9.4c0,5.7-3.6,14.3-5.5,22.2    c-1.6,6.6,3.3,12,9.9,12c11.8,0,20.9-12.5,20.9-30.5c0-15.9-11.5-27.1-27.8-27.1c-18.9,0-30.1,14.2-30.1,28.9    c0,5.7,2.2,11.9,5,15.2c0.5,0.7,0.6,1.2,0.5,1.9c-0.5,2.1-1.6,6.6-1.8,7.5c-0.3,1.2-1,1.5-2.2,0.9c-8.3-3.9-13.5-16-13.5-25.8    c0-21,15.3-40.3,44-40.3c23.1,0,41,16.5,41,38.4c0,22.9-14.5,41.4-34.5,41.4c-6.7,0-13.1-3.5-15.3-7.6c0,0-3.3,12.7-4.1,15.8    c-1.5,5.8-5.6,13-8.3,17.5c6.2,1.9,12.8,3,19.7,3c36.8,0,66.6-29.8,66.6-66.6C138.5,35.2,108.7,5.4,71.9,5.4z" />
    </svg>
  );
};

export const Sidebar = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 1000">
      <path fill="currentColor" d="M47.4,899.3c-20.3,0-37.4-17.1-37.4-38c0-20.6,17.1-38,37.4-38h39.8c20.3,0,37.7,17.4,37.7,38c0,20.9-17.4,38-37.7,38H47.4L47.4,899.3z M318.6,175.6L318.6,175.6c-20.3,0-37.4-16.9-37.4-37.4c0-20.9,17.1-37.4,37.4-37.4H952c20.9,0,38,16.6,38,37.4c0,20.6-17.1,37.4-38,37.4H318.6L318.6,175.6z M47.4,175.6L47.4,175.6c-20.3,0-37.4-16.9-37.4-37.4c0-20.9,17.1-37.4,37.4-37.4h39.8c20.3,0,37.7,16.6,37.7,37.4c0,20.6-17.4,37.4-37.7,37.4H47.4L47.4,175.6z M318.6,416.8L318.6,416.8c-20.3,0-37.4-17.1-37.4-37.7c0-20.8,17.1-37.7,37.4-37.7H952c20.9,0,38,16.8,38,37.7c0,20.6-17.1,37.7-38,37.7H318.6L318.6,416.8z M47.4,416.8L47.4,416.8c-20.3,0-37.4-17.1-37.4-37.7c0-20.8,17.1-37.7,37.4-37.7h39.8c20.3,0,37.7,16.8,37.7,37.7c0,20.6-17.4,37.7-37.7,37.7H47.4L47.4,416.8z M318.6,658.1L318.6,658.1c-20.3,0-37.4-16.8-37.4-37.4c0-20.9,17.1-38,37.4-38H952c20.9,0,38,17.1,38,38c0,20.6-17.1,37.4-38,37.4H318.6L318.6,658.1z M47.4,658.1L47.4,658.1c-20.3,0-37.4-16.8-37.4-37.4c0-20.9,17.1-38,37.4-38h39.8c20.3,0,37.7,17.1,37.7,38c0,20.6-17.4,37.4-37.7,37.4H47.4L47.4,658.1z M318.6,899.3L318.6,899.3c-20.3,0-37.4-17.1-37.4-38c0-20.6,17.1-38,37.4-38H952c20.9,0,38,17.4,38,38c0,20.9-17.1,38-38,38H318.6L318.6,899.3z"></path>
    </svg>
  );
};

export const Star = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 47.94 47.94">
      <path
        fill="currentColor"
        d="M26.285,2.486l5.407,10.956c0.376,0.762,1.103,1.29,1.944,1.412l12.091,1.757
      c2.118,0.308,2.963,2.91,1.431,4.403l-8.749,8.528c-0.608,0.593-0.886,1.448-0.742,2.285l2.065,12.042
      c0.362,2.109-1.852,3.717-3.746,2.722l-10.814-5.685c-0.752-0.395-1.651-0.395-2.403,0l-10.814,5.685
      c-1.894,0.996-4.108-0.613-3.746-2.722l2.065-12.042c0.144-0.837-0.134-1.692-0.742-2.285l-8.749-8.528
      c-1.532-1.494-0.687-4.096,1.431-4.403l12.091-1.757c0.841-0.122,1.568-0.65,1.944-1.412l5.407-10.956
      C22.602,0.567,25.338,0.567,26.285,2.486z"
      />
    </svg>
  );
};

export const TopArrow = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -256 1792 1792" width="100%" height="100%">
      <g transform="matrix(1,0,0,-1,53.152542,1262.6441)">
        <path d="m 1611,565 q 0,-51 -37,-90 l -75,-75 q -38,-38 -91,-38 -54,0 -90,38 L 1024,693 V -11 q 0,-52 -37.5,-84.5 Q 949,-128 896,-128 H 768 q -53,0 -90.5,32.5 Q 640,-63 640,-11 V 693 L 346,400 q -36,-38 -90,-38 -54,0 -90,38 l -75,75 q -38,38 -38,90 0,53 38,91 l 651,651 q 35,37 90,37 54,0 91,-37 l 651,-651 q 37,-39 37,-91 z" fill="currentColor" />
      </g>
    </svg>
  );
};

export const Twitter = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
      <path fill="currentColor" d="M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z" />
    </svg>
  );
};

export const Youtube = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
      <path fill="currentColor" d="M549.655 124.083c-6.281-23.65-24.787-42.276-48.284-48.597C458.781 64 288 64 288 64S117.22 64 74.629 75.486c-23.497 6.322-42.003 24.947-48.284 48.597-11.412 42.867-11.412 132.305-11.412 132.305s0 89.438 11.412 132.305c6.281 23.65 24.787 41.5 48.284 47.821C117.22 448 288 448 288 448s170.78 0 213.371-11.486c23.497-6.321 42.003-24.171 48.284-47.821 11.412-42.867 11.412-132.305 11.412-132.305s0-89.438-11.412-132.305zm-317.51 213.508V175.185l142.739 81.205-142.739 81.201z" />
    </svg>
  );
};
